import { render, staticRenderFns } from "./WorkspaceAlert.vue?vue&type=template&id=2c242de0&scoped=true"
import script from "./WorkspaceAlert.vue?vue&type=script&lang=js"
export * from "./WorkspaceAlert.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceAlert.vue?vue&type=style&index=0&id=2c242de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c242de0",
  null
  
)

export default component.exports